import { UserSessionInfo } from '../../logic/main/types';
import { updateLoginStatus } from '../tracking';
import MessageBus from '../../ports-frontend/MessageBus';
//@TODO: move to more appropriate files
import {
  SessionManagerType,
  AccountInfoType,
  SessionStateType,
} from '../../ports-frontend/types';
import { SessionWatcherCallback } from '../../logic/main/services/watchSession';

export const sessionWatcher = async ({
  callback,
}: {
  callback: SessionWatcherCallback;
}) => {
  let cachedSessionState = '';
  let cachedAccountInfo: UserSessionInfo = {
    loggedIn: false,
    userAccountNumber: '',
    userCurrency: '',
    userStatus: 'non-customer',
    authToken: {
      access_token: '',
    },
    userToken: '', // search-insights
    balance: 0,
    currency: '',
  };

  async function updateSessionInfo(state: SessionStateType) {
    if (state === 'LOGGED_IN') {
      MessageBus.publishEvent({
        topic: 'wh.common.command.account.info.state.get',
      });
      const accountInfo = await waitForAccountInfo();
      const accountId = accountInfo.accountId || '';
      const balance = Number(accountInfo.balance) || 0;
      const currency = accountInfo.currencyCode || '';

      cachedAccountInfo = {
        ...cachedAccountInfo,
        loggedIn: true,
        userAccountNumber: accountId,
        userCurrency: currency,
        balance,
        currency,
      };

      callback({
        type: 'SESSION_STATE_LOGGED_IN',
        data: cachedAccountInfo,
      });
      callback({ type: 'GAMING_USER_DETAILS_FETCHED' });
    }

    if (state === 'NOT_LOGGED_IN') {
      cachedAccountInfo = {
        ...cachedAccountInfo,
        loggedIn: false,
        userAccountNumber: '',
        userCurrency: '',
        authToken: {
          access_token: '',
        },
        userToken: '', // search-insights
        balance: 0,
        currency: '',
      };
      updateLoginStatus(cachedAccountInfo.loggedIn);

      callback({
        type: 'SESSION_STATE_LOGGED_OUT',
        data: cachedAccountInfo,
      });
    }
  }

  async function waitForAccountInfo(): Promise<AccountInfoType> {
    return new Promise(async (resolve, reject) => {
      let unsubscribe: Function;

      try {
        unsubscribe = await MessageBus.onSubscribe(
          ({ payload }: { payload: AccountInfoType }) => {
            if (payload?.state === 'ACCOUNT_INFO_EXISTS' && payload?.balance) {
              unsubscribe();
              resolve(payload);
            }
          },
          [
            'wh.common.event.account.info.state.changed',
            'wh.common.event.account.info.state.get',
          ]
        );
      } catch (err) {
        reject(err);
      }
    });
  }

  const unsubscribe = await MessageBus.onSubscribe(
    ({ payload }: { payload: SessionManagerType }) => {
      const newSessionState = payload?.state;

      if (cachedSessionState !== newSessionState) {
        cachedSessionState = newSessionState;
        updateSessionInfo(newSessionState);
      }
    },
    [
      'wh.common.event.session.state.changed',
      'wh.common.event.session.state.get',
    ]
  );

  MessageBus.publishEvent({ topic: 'wh.common.command.session.state.get' });

  return () => {
    unsubscribe();
  };
};
